// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/user_avatars.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { UserAvatarService } from "./user_avatars";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { BulkGetUserAvatarsResponse } from "./user_avatars";
import type { BulkGetUserAvatarsRequest } from "./user_avatars";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.assets.v1.UserAvatarService
 */
export interface IUserAvatarServiceClient {
    /**
     * @generated from protobuf rpc: BulkGetUserAvatars
     */
    bulkGetUserAvatars(input: BulkGetUserAvatarsRequest, options?: RpcOptions): UnaryCall<BulkGetUserAvatarsRequest, BulkGetUserAvatarsResponse>;
}
/**
 * @generated from protobuf service c1.api.assets.v1.UserAvatarService
 */
export class UserAvatarServiceClient implements IUserAvatarServiceClient, ServiceInfo {
    typeName = UserAvatarService.typeName;
    methods = UserAvatarService.methods;
    options = UserAvatarService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: BulkGetUserAvatars
     */
    bulkGetUserAvatars(input: BulkGetUserAvatarsRequest, options?: RpcOptions): UnaryCall<BulkGetUserAvatarsRequest, BulkGetUserAvatarsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkGetUserAvatarsRequest, BulkGetUserAvatarsResponse>("unary", this._transport, method, opt, input);
    }
}
